import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const packageManagerSelector = createSelector(rootSelector, state => state.packageManager);

export const agentsManagerSelector = createSelector(packageManagerSelector, state => state.agentsManager);

export const themesManagerSelector = createSelector(packageManagerSelector, state => state.themesManager);

export const packageLicensesManagerSelector = createSelector(
  packageManagerSelector,
  state => state.packageLicensesManager
);

export const resourceLicensesManagerSelector = createSelector(
  packageManagerSelector,
  state => state.resourceLicensesManager
);

export const etlSelector = createSelector(packageManagerSelector, state => state.etl);

export const easyLoadingSelector = createSelector(packageManagerSelector, state => state.easyLoading);
